// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-faq-faq-js": () => import("./../../../src/templates/FAQ/faq.js" /* webpackChunkName: "component---src-templates-faq-faq-js" */),
  "component---src-templates-home-home-js": () => import("./../../../src/templates/Home/home.js" /* webpackChunkName: "component---src-templates-home-home-js" */),
  "component---src-templates-index-js": () => import("./../../../src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-templates-sub-topic-sub-topic-js": () => import("./../../../src/templates/SubTopic/subTopic.js" /* webpackChunkName: "component---src-templates-sub-topic-sub-topic-js" */),
  "component---src-templates-topic-topic-js": () => import("./../../../src/templates/Topic/topic.js" /* webpackChunkName: "component---src-templates-topic-topic-js" */)
}

